import { Files } from '../../lib/constants/files'
import { Option } from '../../lib/types/models/options/option'
import { OptionInput } from '../../lib/types/models/options/option-input'
import { UpdateInput } from '../../lib/types/utils'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function updateOption(data: UpdateInput<OptionInput>) {
  const { id, ...rest } = data
  let option = { ...rest }
  const image = await uploadFile(Files.OPTION_PICTO, data.picto)
  const pic = await uploadFile(Files.OPTION_PICTURE, data.picture)
  option = { ...option, picto: image, picture: pic }

  return restApiClient
    .url(constructApiUrl(API.options.update.url, { id }))
    .patch<Option, Partial<OptionInput>>(option)
}
